import Image from 'next/image'

interface Props {
  title: string
  image: StrapiImageFile
  heroBgVideo?: StrapiImageFile
}
function PageHero({ title, image, heroBgVideo }: Props) {
  return (
    <section className="text-white relative h-screen w-screen overflow-hidden">
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src={heroBgVideo?.url}
        autoPlay
        muted
        loop
      />
      <div className="container | absolute inset-0 flex flex-col items-center justify-center gap-7 z-10">
        <Image
          src={image.url}
          alt={image.alternativeText ?? ''}
          width={image.width}
          height={image.height}
          className="object-cover max-w-xs md:max-w-lg"
        />
        {title ? (
          <h1
            className="title text-2xl lg:text-3xl text-center font-medium tracking-tight max-w-xs md:max-w-3xl"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        ) : null}
      </div>
    </section>
  )
}

export default PageHero
